<div class="auth-page">
  <div class="auth-card">
    <div class="auth-header">
      <img src="Logo_QRserve.png" alt="QRServe" class="auth-logo">
      <h2 class="auth-title">Reset Password</h2>
      <p class="auth-subtitle">A code was sent to your email address</p>
    </div>

    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="code" class="form-label">Reset Code</label>
        <div class="input-wrapper">
          <i class="fas fa-key input-icon"></i>
          <input type="text"
                 id="code"
                 formControlName="code"
                 class="form-control"
                 placeholder="Enter your reset code">
        </div>
        @if (message) {
          <div class="field-error">{{ message }}</div>
        }
      </div>

      <button type="submit"
              class="btn btn-primary btn-block submit-btn"
              [disabled]="resetForm.invalid">
        Submit
      </button>
    </form>

    <div class="auth-footer">
      <a [routerLink]="['/login']"><i class="fas fa-arrow-left me-1"></i> Back to login</a>
    </div>
  </div>
</div>
